import lodash from 'lodash'

export function setupScrollWatcher(
  container: HTMLElement,
  {
    threshold = 100,
    gap = 0,
    onReachBottom,
    onReverseScroll
  }: { threshold?: number; gap?: number; onReachBottom?: () => void; onReverseScroll?: (distance: number) => void }
) {
  let lastScrollTop = 0
  let reverseStart: null | number = null

  const onScroll = lodash.throttle(
    () => {
      const { scrollTop, scrollHeight, clientHeight } = container
      // console.warn('onScroll runing~~~', scrollTop, scrollHeight, clientHeight)

      // 1️⃣ 检测是否滚动到底部
      if (scrollTop + clientHeight + gap >= scrollHeight) {
        onReachBottom?.()
      }

      // 2️⃣ 检测反向滚动距离
      if (scrollTop < lastScrollTop) {
        // 开始反向滚动
        if (reverseStart === null) reverseStart = lastScrollTop
        const distance = reverseStart - scrollTop
        if (distance >= threshold) {
          onReverseScroll?.(distance)
          reverseStart = null // 重置
        }
      } else {
        // 向下滚动则重置
        reverseStart = null
      }

      lastScrollTop = scrollTop
    },
    80,
    { leading: true, trailing: true }
  )

  container.addEventListener('scroll', onScroll)

  return () => {
    console.log('清理scroll事件～～～')
    container.removeEventListener('scroll', onScroll)
  }
}
